var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesOpportunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99997 21.5C5.30128 21.5 4.70993 21.258 4.22595 20.774C3.74198 20.29 3.5 19.6987 3.5 19V16.1154H6.5V2.5H20.5V19C20.5 19.6987 20.258 20.29 19.774 20.774C19.29 21.258 18.6987 21.5 18 21.5H5.99997ZM18 20C18.2833 20 18.5208 19.9041 18.7125 19.7125C18.9041 19.5208 19 19.2833 19 19V3.99998H7.99998V16.1154H17V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4791 19.9041 17.7166 20 18 20ZM9.1923 8.69225V7.1923H17.8077V8.69225H9.1923ZM9.1923 11.5769V10.0769H17.8077V11.5769H9.1923ZM5.99997 20H15.5V17.6153H4.99997V19C4.99997 19.2833 5.09581 19.5208 5.28747 19.7125C5.47914 19.9041 5.71664 20 5.99997 20ZM5.99997 20H4.99997H15.5H5.99997Z",
    fill: "black",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOpportunity);
export default __webpack_public_path__ + "static/media/SalesOpportunity.7684dc8bbf94f92381ec216deb0e947e.svg";
export { ForwardRef as ReactComponent };